import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  AULA_AVATAR_BG_COLOUR,
  Avatar,
  Box,
  Icons,
  useTheme,
} from '@ublend-npm/aulaui-core';
import Dropzone from '../../containers/common/Dropzone';

const ProfileUpdate = ({ user, changeAvatar }) => {
  const dropZoneRef = useRef(null);
  const { palette } = useTheme();

  const handleChangeAvatar = useCallback(() => {
    if (dropZoneRef.current) {
      dropZoneRef.current.open();
    }
  }, []);

  const handleDrop = useCallback(
    (files) => {
      if (window.location.href.indexOf('?inbox=') > -1) {
        return false;
      }
      return changeAvatar(files[0]);
    },
    [changeAvatar]
  );

  const getFallbackText = () => {
    const { firstName, lastName } = user;
    return `${firstName ? firstName.charAt(0).toUpperCase() : 'U'}${
      lastName ? lastName.charAt(0).toUpperCase() : ''
    }`.substring(0, 2);
  };

  const { avatar } = user;
  const fallbackText = getFallbackText();

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Dropzone
        ref={dropZoneRef}
        multiple={false}
        accept="image/*"
        onDropAccepted={handleDrop}
      />

      <Box sx={{ position: 'relative', width: 80, height: 80 }}>
        <Avatar
          sx={{
            width: 80,
            height: 80,
            backgroundColor: AULA_AVATAR_BG_COLOUR,
            color: '#ffffff',
          }}
          attributes={{
            container: {
              tabIndex: '0',
              role: 'button',
              'aria-label': 'Upload Image',
            },
          }}
          fallbackText={fallbackText}
          src={avatar}
        />

        {/* Circular Edit Icon */}
        <Box
          component="button"
          aria-label="Edit Image"
          sx={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            border: 0,
            backgroundColor: palette.mode === 'dark' ? '#231F29' : 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            bottom: 0,
            right: 2,
            boxShadow: 1,
            cursor: 'pointer',
          }}
          onClick={handleChangeAvatar}
        >
          <Icons.EditOutlined sx={{ fontSize: '16px' }} color="primary" />
        </Box>
      </Box>
    </Box>
  );
};

ProfileUpdate.propTypes = {
  changeAvatar: PropTypes.func.isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    avatar: PropTypes.string,
    email: PropTypes.string.isRequired,
  }).isRequired,
};

export default ProfileUpdate;
